import {
  GET_USERS_FAIL,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  LOGIN_USER_FAIL,
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGOUT,
  REGISTER_USER_FAIL,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
} from "../types";

const authState = {
  error: null,
  msg: "",
  user: {
    id: "",
    name: "",
    email: "",
    token: "",
    authenticated: false
  },
};
export const AuthReducer = (state = authState, action) => {
  switch (action.type) {
    case LOGIN_USER_REQUEST:
      return { ...state, loading: true };
    case LOGIN_USER_SUCCESS:
      return { ...state, loading: false, user: {...action.payload, authenticated: true} };
    case LOGIN_USER_FAIL:
      return { ...state, loading: false, error: action.payload };
    case REGISTER_USER_REQUEST:
      return { ...state, loading: true };
    case REGISTER_USER_SUCCESS:
      return { ...state, loading: false, user: {...action.payload, authenticated: true} };
    case REGISTER_USER_FAIL:
      return { ...state, loading: false, error: action.payload };
    case LOGOUT:
      return {
        ...state,
        loading: false,
        msg: action.payload,
        error: null,
        user: { id: "", token: "", authenticated: false, name: "", email: "" },
      };
    default:
      return state;
  }
};
export const UsersListReducer = (
  state = { error: null, users: [] },
  action
) => {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return { ...state, loading: true };
    case GET_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case GET_USERS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case LOGOUT:
      return {
        ...state,
        loading: false,
        error: null,
        auth: null,
      };
    default:
      return state;
  }
};
